import React from "react";
import EngagementList from "../Engagements/EngagementList";

const inspectionCycleHiddenColumns = [
  "assignedTo",
  "progress",
  "riskLevel",
  "dueDate",
  "status",
];

export default function InspectionCycleEngagementList(props) {
  return (
    <EngagementList {...props} hiddenColumns={inspectionCycleHiddenColumns} />
  );
}
